import { AxiosRequestConfig } from "axios";

// Full config:  https://github.com/axios/axios#request-config

export const AxiosConfig: AxiosRequestConfig = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};
